import React from 'react'
import moment from 'moment'
import { FC, MouseEvent, CSSProperties } from 'react'
import styles from './style.module.scss'

interface WeekHeaderProps {
  date: Date
  isToday: boolean
  onDoubleClick: (e: MouseEvent<HTMLDivElement>, date: Date) => void
}

const WeekHeader: FC<WeekHeaderProps> = ({ date, isToday, onDoubleClick }) => {
  // 날짜 포맷팅
  const formattedDate = moment(date)
  const dayNumber = formattedDate.format('D')
  const dayName = formattedDate.format('ddd') // 요일 약자 사용 (월~일)

  // 요일 확인 (0: 일요일, 6: 토요일)
  const dayOfWeek = formattedDate.day()
  const isSunday = dayOfWeek === 0
  const isSaturday = dayOfWeek === 6

  // 요일별 스타일 클래스 결정 (isToday가 우선)
  const getDayNumberClass = (): string => {
    if (isToday) return styles.todayNumber
    return styles.dayNumber
  }

  const getDayNameClass = (): string => {
    return styles.dayName
  }

  const getDayNameStyle = (): CSSProperties => {
    if (isSunday) return { color: '#FD4C45' }
    if (isSaturday) return { color: '#3362FF' }
    return {}
  }

  return (
    <div className={styles.weekHeader} onDoubleClick={(e) => onDoubleClick(e, date)}>
      <div className={getDayNameClass()} style={getDayNameStyle()}>
        {dayName}
      </div>
      <div className={getDayNumberClass()}>{dayNumber}</div>
    </div>
  )
}

export default WeekHeader
